/* Da Vinci - popups de captura */
(function () {
  var root = document.getElementById('DvPopup');
  if (!root) return;
  var teaser = document.getElementById('DvPopTeaser');
  var K = { sub: 'dvpop_subscribed', closed: 'dvpop_closed_at', cart: 'dvpop_cart_shown' };
  var store = {
    get: function (s, k) { try { return window[s].getItem(k); } catch (e) { return null; } },
    set: function (s, k, v) { try { window[s].setItem(k, v); } catch (e) {} }
  };
  var d = root.dataset;
  var days = parseInt(d.days, 10) || 7;
  var isBF = d.bfEnd ? Date.now() < Date.parse(d.bfEnd) : false;
  var lastFocus = null, current = null, armed = true;
  var t0 = Date.now();
  var MIN_MS = 8000; // nunca cobrir a pagina antes de 8s

  // Conta paginas vistas na sessao; 1a pagina vinda de anuncio em produto nao recebe popup de cadastro
  var views = (parseInt(store.get('sessionStorage', 'dvpop_views'), 10) || 0) + 1;
  store.set('sessionStorage', 'dvpop_views', String(views));
  var qs = location.search;
  var fromAd = /[?&](utm_|gclid=|gbraid=|wbraid=|fbclid=|ttclid=|msclkid=)/.test(qs) ||
    (document.referrer && document.referrer.indexOf(location.hostname) === -1 && /facebook|instagram|google|tiktok|youtube|pinterest/.test(document.referrer));
  var adLanding = views === 1 && (d.template || (document.querySelector('main[data-template]') || {dataset:{}}).dataset.template || '').split('.')[0] === 'product' && fromAd;

  root.querySelectorAll('.dv-pop__bf-only').forEach(function (el) { el.hidden = !isBF; });
  root.querySelectorAll('.dv-pop__nobf-only').forEach(function (el) { el.hidden = isBF; });

  function view(name) { return root.querySelector('[data-dv-view="' + name + '"]'); }
  function subscribed() { return d.subscriber === 'true' || store.get('localStorage', K.sub) === '1'; }
  function recentlyClosed() {
    var t = parseInt(store.get('localStorage', K.closed), 10);
    return t && Date.now() - t < days * 864e5;
  }

  function open(name) {
    if (current) return;
    var v = view(name);
    if (!v) return;
    current = name; armed = false;
    lastFocus = document.activeElement;
    root.hidden = false; v.hidden = false;
    if (teaser) teaser.hidden = true;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    var f = v.querySelector('input[type=email]') || v.querySelector('.dv-pop__btn');
    setTimeout(function () { f && f.focus({ preventScroll: true }); }, 60);
    if (window.dataLayer) window.dataLayer.push({ event: 'dv_popup_open', popup: name });
  }

  function close() {
    if (!current) return;
    var name = current;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; view(name).hidden = true; }, 250);
    current = null;
    if (name === 'signup' && !subscribed()) {
      store.set('localStorage', K.closed, String(Date.now()));
      if (teaser) teaser.hidden = false;
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-dv-close]')) close();
    var c = e.target.closest('[data-dv-copy]');
    if (c) {
      var code = c.getAttribute('data-dv-copy');
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(
        function () { c.textContent = 'Copiado!'; },
        function () { c.textContent = code; }
      );
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!current) return;
    if (e.key === 'Escape') return close();
    if (e.key === 'Tab') {
      var items = view(current).querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden])');
      items = Array.prototype.filter.call(items, function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  if (teaser) teaser.addEventListener('click', function () { open('signup'); });

  // Perfil escolhido vira tag do cliente (segmentacao do e-mail marketing)
  var form = document.getElementById('DvPopForm');
  if (form) form.addEventListener('submit', function () {
    var tags = form.querySelector('[data-dv-tags]');
    var p = form.querySelector('input[name=dv_profile]:checked');
    if (tags && p) tags.value = 'newsletter,popup-captura,' + p.value + (isBF ? ',black-friday-2026' : '');
    store.set('localStorage', K.closed, String(Date.now()));
  });

  // Volta do envio: mostra sucesso ou erro na hora
  var justPosted = /[?&]customer_posted=true/.test(qs) || location.hash === '#DvPopForm';
  if (justPosted && root.querySelector('[data-dv-success]')) {
    store.set('localStorage', K.sub, '1');
    if (window.dataLayer) window.dataLayer.push({ event: 'dv_popup_signup' });
    return open('signup');
  }
  if (justPosted && root.querySelector('[data-dv-error]')) return open('signup');

  // ----- Gatilhos do cadastro -----
  var canSignup = !subscribed() && !recentlyClosed() && !adLanding;
  if (!canSignup && !subscribed() && teaser) teaser.hidden = false;

  function trySignup() {
    if (!armed || !canSignup) return;
    var wait = MIN_MS - (Date.now() - t0);
    if (wait > 0) return setTimeout(trySignup, wait);
    open('signup');
  }
  if (canSignup) {
    var delay = Math.max(parseInt(d.delay, 10) || 9, 8) * 1000;
    setTimeout(trySignup, delay);
    // primeira rolagem de verdade (30% da altura da tela); ainda respeita o minimo de 8s
    var startY = window.scrollY;
    var onScroll = function () {
      if (Math.abs(window.scrollY - startY) > window.innerHeight * 0.3) { window.removeEventListener('scroll', onScroll); trySignup(); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ----- Saida (desktop): carrinho com itens > lembrete; senao > cadastro -----
  var desktop = window.matchMedia('(pointer:fine) and (min-width:750px)').matches;
  if (desktop && (d.exit === 'true' || d.cartPopup === 'true')) {
    setTimeout(function () {
      document.addEventListener('mouseout', function onOut(e) {
        if (e.relatedTarget || e.clientY > 10 || current || Date.now() - t0 < MIN_MS) return;
        handleExit();
      });
    }, 4000);
  }

  function money(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function handleExit() {
    if (d.cartPopup === 'true' && store.get('sessionStorage', K.cart) !== '1') {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && cart.item_count > 0) {
            store.set('sessionStorage', K.cart, '1');
            var min = parseInt(d.freeShip, 10) || 0;
            var total = cart.total_price;
            var txt = root.querySelector('[data-dv-ship-text]');
            var bar = root.querySelector('[data-dv-ship-bar]');
            var n = cart.item_count + (cart.item_count === 1 ? ' item' : ' itens');
            if (min && total < min) {
              txt.textContent = 'Você tem ' + n + ' no carrinho. Faltam só ' + money(min - total) + ' para ganhar frete grátis.';
              bar.parentNode.hidden = false;
              setTimeout(function () { bar.style.width = Math.round(total / min * 100) + '%'; }, 300);
            } else {
              txt.textContent = 'Você tem ' + n + ' no carrinho' + (min ? ' e já garantiu frete grátis.' : '.') + (isBF ? ' Os itens da Black Friday já estão com 20% OFF.' : '');
              bar.parentNode.hidden = true;
            }
            open('cart');
          } else if (d.exit === 'true') {
            trySignup();
          }
        })
        .catch(function () { if (d.exit === 'true') trySignup(); });
    } else if (d.exit === 'true') {
      trySignup();
    }
  }
})();
